const POLYGON_OPTS_MAP = {
  SERVICEABLE_AREA: {
    fillColor: "#81ae76",
    strokeColor: "#81ae76",
    fillOpacity: 0.2,
    strokeWeight: 2,
    strokeOpacity: 1,
    suppressUndo: true,
    zIndex: 1000
  },
  NON_SERVICEABLE_AREA: {
    fillColor: "#cd6161",
    strokeColor: "#cd6161",
    fillOpacity: 0.7,
    strokeWeight: 2,
    strokeOpacity: 1,
    suppressUndo: true,
    zIndex: 3000
  },
  BUDDY_BLOCK: {
    fillColor: "#ddbb60",
    strokeColor: "#ddbb60",
    fillOpacity: 0.5,
    strokeWeight: 2,
    strokeOpacity: 1,
    suppressUndo: true,
    zIndex: 2000
  },
  WAREHOUSE_FENCE: {
    fillColor: "#2185ff",
    strokeColor: "#2185ff",
    fillOpacity: 0.25,
    strokeWeight: 2,
    strokeOpacity: 0.5,
    suppressUndo: true,
    zIndex: 1100
  }
};
export const heatmapGradient = [
  "rgba(168,149,183,0)",
  "rgba(168,149,183,1)",
  "rgba(168,150,182,1)",
  "rgba(167,151,182,1)",
  "rgba(167,151,181,1)",
  "rgba(166,152,181,1)",
  "rgba(166,153,180,1)",
  "rgba(165,154,179,1)",
  "rgba(165,154,179,1)",
  "rgba(164,155,178,1)",
  "rgba(164,156,178,1)",
  "rgba(164,157,177,1)",
  "rgba(163,157,176,1)",
  "rgba(163,158,176,1)",
  "rgba(162,159,175,1)",
  "rgba(162,160,175,1)",
  "rgba(161,160,174,1)",
  "rgba(161,161,173,1)",
  "rgba(160,162,173,1)",
  "rgba(160,163,172,1)",
  "rgba(160,164,172,1)",
  "rgba(159,164,171,1)",
  "rgba(159,165,170,1)",
  "rgba(158,166,170,1)",
  "rgba(158,167,169,1)",
  "rgba(157,167,169,1)",
  "rgba(157,168,168,1)",
  "rgba(157,169,167,1)",
  "rgba(156,170,167,1)",
  "rgba(156,170,166,1)",
  "rgba(155,171,166,1)",
  "rgba(155,172,165,1)",
  "rgba(154,173,164,1)",
  "rgba(154,173,164,1)",
  "rgba(153,174,163,1)",
  "rgba(153,175,162,1)",
  "rgba(153,176,162,1)",
  "rgba(152,176,161,1)",
  "rgba(152,177,161,1)",
  "rgba(151,178,160,1)",
  "rgba(151,179,159,1)",
  "rgba(150,180,159,1)",
  "rgba(150,180,158,1)",
  "rgba(149,181,158,1)",
  "rgba(149,182,157,1)",
  "rgba(149,183,156,1)",
  "rgba(148,183,156,1)",
  "rgba(148,184,155,1)",
  "rgba(147,185,155,1)",
  "rgba(147,186,154,1)",
  "rgba(146,186,153,1)",
  "rgba(146,187,153,1)",
  "rgba(147,188,152,1)",
  "rgba(148,189,150,1)",
  "rgba(148,190,149,1)",
  "rgba(149,191,148,1)",
  "rgba(150,192,147,1)",
  "rgba(151,193,146,1)",
  "rgba(151,194,145,1)",
  "rgba(152,195,143,1)",
  "rgba(153,196,142,1)",
  "rgba(153,196,141,1)",
  "rgba(154,197,140,1)",
  "rgba(155,198,139,1)",
  "rgba(156,199,138,1)",
  "rgba(156,200,136,1)",
  "rgba(157,201,135,1)",
  "rgba(158,202,134,1)",
  "rgba(158,203,133,1)",
  "rgba(159,204,132,1)",
  "rgba(160,205,131,1)",
  "rgba(161,206,129,1)",
  "rgba(161,207,128,1)",
  "rgba(162,208,127,1)",
  "rgba(163,208,126,1)",
  "rgba(164,209,125,1)",
  "rgba(164,210,124,1)",
  "rgba(165,211,122,1)",
  "rgba(166,212,121,1)",
  "rgba(166,213,120,1)",
  "rgba(167,214,119,1)",
  "rgba(168,215,118,1)",
  "rgba(169,216,117,1)",
  "rgba(169,217,115,1)",
  "rgba(170,218,114,1)",
  "rgba(171,219,113,1)",
  "rgba(172,220,112,1)",
  "rgba(172,221,111,1)",
  "rgba(173,221,110,1)",
  "rgba(174,222,108,1)",
  "rgba(174,223,107,1)",
  "rgba(175,224,106,1)",
  "rgba(176,225,105,1)",
  "rgba(177,226,104,1)",
  "rgba(177,227,103,1)",
  "rgba(178,228,101,1)",
  "rgba(179,229,100,1)",
  "rgba(179,230,99,1)",
  "rgba(180,231,98,1)",
  "rgba(181,232,97,1)",
  "rgba(182,233,96,1)",
  "rgba(183,233,95,1)",
  "rgba(184,233,95,1)",
  "rgba(185,233,95,1)",
  "rgba(186,233,95,1)",
  "rgba(187,233,95,1)",
  "rgba(189,233,95,1)",
  "rgba(190,233,95,1)",
  "rgba(191,233,95,1)",
  "rgba(192,233,95,1)",
  "rgba(193,233,95,1)",
  "rgba(194,233,95,1)",
  "rgba(196,233,95,1)",
  "rgba(197,232,95,1)",
  "rgba(198,232,95,1)",
  "rgba(199,232,95,1)",
  "rgba(200,232,95,1)",
  "rgba(202,232,95,1)",
  "rgba(203,232,95,1)",
  "rgba(204,232,95,1)",
  "rgba(205,232,95,1)",
  "rgba(206,232,95,1)",
  "rgba(207,232,95,1)",
  "rgba(209,232,95,1)",
  "rgba(210,232,95,1)",
  "rgba(211,232,95,1)",
  "rgba(212,232,95,1)",
  "rgba(213,232,95,1)",
  "rgba(215,232,95,1)",
  "rgba(216,232,95,1)",
  "rgba(217,232,95,1)",
  "rgba(218,232,95,1)",
  "rgba(219,232,95,1)",
  "rgba(221,232,95,1)",
  "rgba(222,232,95,1)",
  "rgba(223,232,95,1)",
  "rgba(224,232,95,1)",
  "rgba(225,232,95,1)",
  "rgba(226,231,95,1)",
  "rgba(228,231,95,1)",
  "rgba(229,231,95,1)",
  "rgba(230,231,95,1)",
  "rgba(231,231,95,1)",
  "rgba(232,231,95,1)",
  "rgba(234,231,95,1)",
  "rgba(235,231,95,1)",
  "rgba(236,231,95,1)",
  "rgba(237,231,95,1)",
  "rgba(238,231,95,1)",
  "rgba(240,231,95,1)",
  "rgba(241,231,95,1)",
  "rgba(241,229,95,1)",
  "rgba(241,227,95,1)",
  "rgba(241,225,95,1)",
  "rgba(241,223,95,1)",
  "rgba(241,221,95,1)",
  "rgba(241,219,95,1)",
  "rgba(240,217,95,1)",
  "rgba(240,215,95,1)",
  "rgba(240,213,95,1)",
  "rgba(240,211,95,1)",
  "rgba(240,209,95,1)",
  "rgba(240,207,95,1)",
  "rgba(240,205,96,1)",
  "rgba(240,203,96,1)",
  "rgba(240,200,96,1)",
  "rgba(240,198,96,1)",
  "rgba(240,196,96,1)",
  "rgba(240,194,96,1)",
  "rgba(239,192,96,1)",
  "rgba(239,190,96,1)",
  "rgba(239,188,96,1)",
  "rgba(239,186,96,1)",
  "rgba(239,184,96,1)",
  "rgba(239,182,96,1)",
  "rgba(239,180,96,1)",
  "rgba(239,178,96,1)",
  "rgba(239,176,96,1)",
  "rgba(239,174,96,1)",
  "rgba(239,171,96,1)",
  "rgba(239,169,96,1)",
  "rgba(239,167,96,1)",
  "rgba(238,165,96,1)",
  "rgba(238,163,96,1)",
  "rgba(238,161,96,1)",
  "rgba(238,159,96,1)",
  "rgba(238,157,96,1)",
  "rgba(238,155,96,1)",
  "rgba(238,153,97,1)",
  "rgba(238,151,97,1)",
  "rgba(238,149,97,1)",
  "rgba(238,147,97,1)",
  "rgba(238,145,97,1)",
  "rgba(238,142,97,1)",
  "rgba(237,140,97,1)",
  "rgba(237,138,97,1)",
  "rgba(237,136,97,1)",
  "rgba(237,134,97,1)",
  "rgba(237,132,97,1)",
  "rgba(237,130,97,1)",
  "rgba(237,128,97,1)"
];

export const clusterStyles = [
  {
    width: 30,
    height: 30,
    className: "custom-clustericon-1"
  },
  {
    width: 40,
    height: 40,
    className: "custom-clustericon-2"
  },
  {
    width: 50,
    height: 50,
    className: "custom-clustericon-3"
  }
];

export const geofenceCategoryValueToTextMap = {
  SERVICEABLE_AREA: "Serviceable Area",
  NON_SERVICEABLE_AREA: "Non Serviceable Area",
  BUDDY_BLOCK: "Buddy Block",
  WAREHOUSE_FENCE: "Warehouse Fence"
};
export const mapGoogleMapPolygonToGeoJSONPolygon = (polygon, opts, _id) => {
  if (!polygon) return null;
  const geometry = {
    type: "Polygon"
  };
  let polygonJson;
  if (_id) {
    polygonJson = {
      _id,
      type: "Feature",
      geometry,
      properties: {
        ...opts
      }
    };
  } else {
    polygonJson = {
      type: "Feature",
      geometry,
      properties: {
        ...opts
      }
    };
  }

  geometry.coordinates = polygon
    .getPaths()
    .getArray()
    .map(path => {
      const p = path.getArray().map(coord => [coord.lng(), coord.lat()]);
      if (!(p[0][0] === p[p.length - 1][0] && p[0][1] === p[p.length - 1][1])) {
        p.push(p[0]);
      }
      return p;
    });
  return polygonJson;
};

export const getPolygonOptions = (category, editable) => {
  return {
    ...POLYGON_OPTS_MAP[category],
    editable
  };
};

export const mapGeoJSONPolygonToGoogleMapPolygon = (
  polygon,
  editable = false
) => {
  if (!polygon.geometry.coordinates) return null;
  const paths = polygon.geometry.coordinates.map(path => {
    const p = path.map(coord => {
      return { lat: coord[1], lng: coord[0] };
    });
    p.pop();
    return p;
  });
  const options = getPolygonOptions(polygon.properties.fenceCategory, editable);
  return { paths, options };
};

export const removeVertextFromGeoJSONPolygon = (vertexIndex, geoJson) => {
  const updatedCoordinates = geoJson.geometry.coordinates
    .map(path => {
      if (path.length <= 4) {
        return null;
      }
      if (vertexIndex === 0) {
        const newPath = path.slice(1, path.length - 1);
        newPath.push(newPath[0]);
        return newPath;
      }
      return path.filter((coord, index) => index !== vertexIndex);
    })
    .filter(e => e !== null);
  if (updatedCoordinates.length === 0) {
    return null;
  }
  const updatedGeoJson = { ...geoJson };
  updatedGeoJson.geometry.coordinates = updatedCoordinates;
  return updatedGeoJson;
};

const orientation = (p, q, r) => {
  // See https://www.geeksforgeeks.org/orientation-3-ordered-points/
  // for details of below formula.
  const val = (q[1] - p[1]) * (r[0] - q[0]) - (q[0] - p[0]) * (r[1] - q[1]);
  if (val === 0) return 0; // colinear
  return val > 0 ? 1 : 2; // clock or counterclock wise
};

// Given three colinear points p, q, r, the function checks if
// point q lies on line segment 'pr'
const onSegment = (p, q, r) => {
  if (
    q[0] <= Math.max(p[0], r[0]) &&
    q[0] >= Math.min(p[0], r[0]) &&
    q[1] <= Math.max(p[1], r[1]) &&
    q[1] >= Math.min(p[1], r[1])
  )
    return true;

  return false;
};

// Using this algo:
// https://www.geeksforgeeks.org/check-if-two-given-line-segments-intersect/
export const twoLineIntersect = (p1, q1, p2, q2) => {
  // Find the four orientations needed for general and
  // special cases
  const o1 = orientation(p1, q1, p2);
  const o2 = orientation(p1, q1, q2);
  const o3 = orientation(p2, q2, p1);
  const o4 = orientation(p2, q2, q1);

  // General case
  if (o1 !== o2 && o3 !== o4) return true;

  // Special Cases
  // p1, q1 and p2 are colinear and p2 lies on segment p1q1
  if (o1 === 0 && onSegment(p1, p2, q1)) return true;

  // p1, q1 and q2 are colinear and q2 lies on segment p1q1
  if (o2 === 0 && onSegment(p1, q2, q1)) return true;

  // p2, q2 and p1 are colinear and p1 lies on segment p2q2
  if (o3 === 0 && onSegment(p2, p1, q2)) return true;

  // p2, q2 and q1 are colinear and q1 lies on segment p2q2
  if (o4 === 0 && onSegment(p2, q1, q2)) return true;

  return false; // Doesn't fall in any of the above cases
};

// Assuming Polygon was not self intersecting and without
// holes before moving vertex at vertexIndex.
// Check if polygon self int)rsect due to
// moving vertex at vertexIndex to it's current position
export const polygonVertexCauseSelfIntersection = (
  geofenceJson,
  vertexIndex
) => {
  // user can't select last index of actual geojson path as it's marker
  // not shown on map as it's same as 0th index.
  // Moreover google map requires so too. So not including it in slice
  const path = geofenceJson.geometry.coordinates[0].slice(0, -1);
  let p1 = path[vertexIndex];
  let i = (vertexIndex + 1) % path.length;
  let q1 = path[i];
  i = (i + 1) % path.length;
  const stopCondn =
    vertexIndex - 1 < 0 ? path.length + (vertexIndex - 1) : vertexIndex - 1;
  while (i !== stopCondn) {
    let p2 = path[i];
    i = (i + 1) % path.length;
    let q2 = path[i];
    if (twoLineIntersect(p1, q1, p2, q2)) {
      return true;
    }
  }
  p1 = path[vertexIndex];
  i = vertexIndex - 1 < 0 ? path.length + (vertexIndex - 1) : vertexIndex - 1;
  q1 = path[i];
  i = i - 1 < 0 ? path.length + (i - 1) : i - 1;
  while (i !== (vertexIndex + 1) % path.length) {
    let p2 = path[i];
    i = i - 1 < 0 ? path.length + (i - 1) : i - 1;
    let q2 = path[i];
    if (twoLineIntersect(p1, q1, p2, q2)) {
      return true;
    }
  }
  return false;
};
